import { Proposal, approvedProposalAttachment } from "./proposalsModel"
import AttachmentUrl from "./AttachmentUrl"

type Props = {
    latestProposal: Proposal
}

const ApprovedAttachmentUrl = ({latestProposal }: Props) => {
    return <>
        Approved { latestProposal.isApproved && latestProposal.approvedAttachmentId != null && 
            <AttachmentUrl 
                attachmentId={latestProposal.approvedAttachmentId!}
                attachmentType={approvedProposalAttachment}
            />}
  </>
}

export default ApprovedAttachmentUrl